<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      My Devices
    </div>
    <div class="content">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          pulling-text="Pull down to refresh"
          loading-text="Loading..."
          success-text="Refresh success"
          loosing-text="Release to refresh"
      >
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="No more data"
            loading-text="Loading more..."
            :error.sync="error"
            error-text="Load fail! Click reload"
        >
<!--          @load="onLoad"-->

          <MyDeviceItem
              @click="onItemClick(item,index)"
              v-for="(item, index) in historyList"
              :device="item"
              :key="index"/>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import log from "@/util/log";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import { calcMaxPower, calcPower, calcVoltageFloorInt } from "../util/utils";
import HistoryCurve from "@/views/HistoryCurve.vue";
import { mapState } from "vuex";
import CurveItem from "@/components/history/CurveItem.vue";
import user from "@/api/user";
import userMixin from "@/mixins/userMixin";
import SystemCurve from "@/components/home/SystemCurve.vue";
import SystemCurveItem from "@/components/home/SystemCurveItem.vue";
import ConsumerCurveItem from "@/components/history/ConsumerCurveItem.vue";
import NotificationItem from "@/components/notification/NotificationItem.vue";
import MyDeviceItem from "@/components/MyDeviceItem.vue";

export default {
  name: "MyDevices",
  mixins: [userMixin],
  components: {
    MyDeviceItem,
    NotificationItem,
    ConsumerCurveItem,
    SystemCurveItem,
    SystemCurve,
    CurveItem,
    HistoryCurve
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      historyList: [],
      pageNum: 1,
      pageSize: 10
    };
  },
  created() {
  },

  computed: {
    ...mapState("theme", ["curveColor", "curveLineColor", "syncButtonColor"])
  },
  methods: {
    onItemClick(item,index) {
      this.$router.push({
        name: 'MyFavoriteDevice',
        query: {
          brandId: item.id
        }
      })
    },
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onApply(index, item) {
      const writerSetting = new WriterSetting();
      Object.assign(writerSetting, item);
      const name = this.$route.query.modelType == 1 ? "Enterprise" : "BtHome";
      this.$router.replace({
        name,
        params: {
          writerSetting
        }
      });
    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onLoad() {
      //如果是刷新
      if (this.refreshing) {
        this.pageNum = 1;
        this.historyList = [];
      }
      try {
        let response = await this.$api.User.selectMyDevices({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          modelType: this.$route.query.modelType || 0
        });
        const history = response.data;
        const total = response.total;
        // log(history);
        this.historyList = this.historyList.concat(history)
        //刷新结束
        if (this.refreshing) {
          this.refreshing = false;
        } else {
          this.loading = false;
        }
        if (this.historyList.length >= total) {
          this.finished = true;
        }
        this.pageNum += 1;
      } catch (e) {
        log(e);
        this.loading = false;
        this.error = true;
      }finally {
        this.finished = true
      }
    },
    calcHistoryPower(voltage, r, maxPower) {
      return calcPower(voltage, r, maxPower);
    }
  },
  async mounted() {
    this.onLoad()
  },
};
//圆点
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #545554;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    height: 100%;
    overflow-y: auto;
    background: #f6f6f6;

    .notification-item {
      margin-left: 16px;
      margin-right: 16px;
      border-radius: 12px;
    }
  }
}

.van-list {
  text-align: center;

  & > * {
    margin-top: 12px;
  }

}
</style>
